import React from "react";

const Plano = () => {
  return <h1>Teste</h1>;
};

export default Plano;
